<template>
  <div class="radio_content">
      <span 
        v-for="item in options" 
        :key="item.value" 
        :class="{ 'radio_item':true,'action_radio_item':value===item.value }"
        @click="handleClick(item.value)"
      >
        {{ item.label }}
      </span>
  </div>
</template>

<script>
  export default {
    name:'Radio',
    model: {
      props: 'value',
      event: 'change'
    },
    props:{
      options:{
        type:Array,
        default:()=>[],
      },
      value:{
        type:String,
        default:''
      }
    },
    methods:{
      handleClick(value){
        this.$emit('change',value)
      }
    }
  }
</script>

<style lang="less" scoped>
  .radio_content{
    padding: 2px;
    border-radius: 4px;
    background-color: #F0F2F5;
    display: inline-flex;
    align-items: center;
  }
  .radio_item{
    display: inline-block;
    line-height: 32px;
    padding: 0 20px;
    border-radius: 4px;
    cursor: pointer;
  }
  .action_radio_item{
    background: #059E84;
    color: #fff;
    border: 1px solid transparent;
  }
</style>